import { Cell, Header } from "@tanstack/react-table";
import * as React from "react";
import cn from "clsx";
import { CardTableItem, useCardTableContext } from "../context/CardTableContext";

export interface BaseCellRenderProps<T> {
  cell: Cell<T, unknown> | Header<T, unknown>;
  customClasses?: string;
  render: React.ReactNode;
  index: number;
}
export const BaseCellRender = <T extends CardTableItem>({
  cell,
  customClasses,
  render,
  index,
}: BaseCellRenderProps<T>) => {
  const { customWidth, fixed, minWidth } = cell.column.columnDef.meta || {};

  const { isScrolled } = useCardTableContext();
  const [offsetLeft, setOffsetLeft] = React.useState(0);

  const measuredRef = React.useCallback((node) => {
    if (node !== null) {
      setOffsetLeft(node.offsetLeft);
    }
  }, []);

  return (
    <div
      ref={measuredRef}
      className={cn(
        (index === 0 || fixed) && "zindex-1",
        customWidth ?? "col",
        fixed && "position-sticky",
        fixed && isScrolled && "overflow-shadow-start",
        customClasses
      )}
      style={{
        minWidth: minWidth ?? 50,
        left: fixed ? offsetLeft : 0,
      }}
    >
      {render}
    </div>
  );
};
